import React from "react";
import { MapPin } from "lucide-react";
import { ScrollArea } from "../ui/scroll-area";

// Featured Videos panel inside the home player overlay. Extracted from
// FeedPlayerOverlay.jsx in Iter-Feb 2026. Pure prop-driven — owns no state.
const FeedFeaturedVideosPanel = ({ featuredVideos, navigate, handleClosePlayer }) => {
  return (
    <div className="w-full p-2 flex flex-col flex-1 min-h-0">
      <p className="text-gray-400 text-[10px] uppercase tracking-wide mb-1 flex-shrink-0">Featured Videos</p>
      <ScrollArea className="flex-1 min-h-0">
        <div className="space-y-1">
          {featuredVideos.length > 0 ? featuredVideos.map((video) => (
            <button
              key={video.id}
              onClick={() => {
                handleClosePlayer();
                navigate(`/${video.username}?video=${video.id}`);
              }}
              className="w-full text-left p-1.5 rounded bg-gray-900/50 hover:bg-gray-700/50 transition-colors group"
            >
              <p className="text-white text-xs truncate group-hover:text-emerald-400 transition-colors">{video.title}</p>
              <p className="text-gray-500 text-[10px] flex items-center gap-1">
                <MapPin className="h-2.5 w-2.5" />
                {video.location?.city || "Unknown"}, {video.location?.country || ""}
              </p>
            </button>
          )) : (
            <p className="text-gray-500 text-xs text-center py-2">No featured videos</p>
          )}
        </div>
      </ScrollArea>
    </div>
  );
};

export default FeedFeaturedVideosPanel;
